import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const subscribePlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUBSCRIBE_PLAN_START:
      return { ...state, loading: true, data: null, error: null };
    case types.SUBSCRIBE_PLAN_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case types.SUBSCRIBE_PLAN_ERROR:
      return { ...state, loading: false, error: action.payload };
    case types.SUBSCRIBE_PLAN_RESET:
      return initialState;
    default:
      return state;
  }
};

export default subscribePlanReducer;
